var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInbox = function SvgInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#666060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1 10.875h3.75L6 12.188h5l1.25-1.313H16M2.875 16.5A1.875 1.875 0 0 1 1 14.625V3.375C1 2.339 1.84 1.5 2.875 1.5h11.25C15.161 1.5 16 2.34 16 3.375v11.25c0 1.036-.84 1.875-1.875 1.875z"
  })));
};
export default SvgInbox;